import React from 'react';
import LoginScreen from '../../components/screen/LoginScreen';

const Login = () => <LoginScreen />;
export default Login;
